import { useCallback, useEffect } from 'react'

export const useAdobeTagmanagerScript = (url: string | undefined, nonce: string, isEnabled: boolean): void => {
  const script = useCallback(() => {
    const scriptElement = document.createElement('script')

    if (url && isEnabled) {
      scriptElement.src = url
      scriptElement.async = true
      scriptElement.setAttribute('nonce', nonce)
      document.head.appendChild(scriptElement)
    }

    return () => {
      try {
        document.head.removeChild(scriptElement)
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }, [url, nonce, isEnabled])

  useEffect(() => {
    script()
  }, [script])
}
